export enum ViewAs {
  TUTOR = 'tutor',
  SEEKER = 'schueler',
}

export enum LessonTypePreset {
  PAST = 'past',
  ONGOING_OR_UPCOMING = 'ongoing_or_upcoming',
}
